import { PartnerType } from "@/app/utils/partners.enum";

export enum SupportRequestStatusEnum {
  OPEN = "OPEN",
  IN_PROGRESS = "IN_PROGRESS",
  ESCALATED_TECHNICAL = "ESCALATED_TECHNICAL",
  AWAITING_SELLER = "AWAITING_SELLER",
  RESOLVED = "RESOLVED",
  CLOSED = "CLOSED",
  CANCELLED = "CANCELLED",
}

export const SUPPORT_STATUS_LABEL: Record<SupportRequestStatusEnum, string> = {
  [SupportRequestStatusEnum.OPEN]: "Aberto",
  [SupportRequestStatusEnum.IN_PROGRESS]: "Em atendimento",
  [SupportRequestStatusEnum.ESCALATED_TECHNICAL]: "Escalado ao técnico",
  [SupportRequestStatusEnum.AWAITING_SELLER]: "Aguardando resposta",
  [SupportRequestStatusEnum.RESOLVED]: "Resolvido",
  [SupportRequestStatusEnum.CLOSED]: "Fechado",
  [SupportRequestStatusEnum.CANCELLED]: "Cancelado",
};

export const SUPPORT_STATUS_BADGE_CLASSNAME: Record<
  SupportRequestStatusEnum,
  string
> = {
  [SupportRequestStatusEnum.OPEN]:
    "bg-yellow-100/50 text-yellow-500 hover:bg-yellow-100/80",
  [SupportRequestStatusEnum.IN_PROGRESS]:
    "bg-blue-100/60 text-blue-600 hover:bg-blue-100",
  [SupportRequestStatusEnum.ESCALATED_TECHNICAL]:
    "bg-primary/10 text-primary hover:bg-primary/20",
  [SupportRequestStatusEnum.AWAITING_SELLER]:
    " bg-yellow-100/50 text-yellow-500 hover:bg-yellow-100/80",
  [SupportRequestStatusEnum.RESOLVED]:
    "bg-primary/10 text-primary hover:bg-primary/20",
  [SupportRequestStatusEnum.CLOSED]:
    "bg-gray02 text-black04 hover:bg-gray02/80",
  [SupportRequestStatusEnum.CANCELLED]:
    "bg-error/10 text-error hover:bg-error/20",
};

export const optionsSupportRequestStatusSelect = Object.values(
  SupportRequestStatusEnum,
).map((status) => ({
  value: status,
  label: SUPPORT_STATUS_LABEL[status],
}));

export enum SupportRequestReason {
  PROPOSAL_QUESTION = "PROPOSAL_QUESTION",
  PROPOSAL_STUCK = "PROPOSAL_STUCK",
  PLATFORM_BUG = "PLATFORM_BUG",
  DOCUMENT_UPLOAD_ISSUE = "DOCUMENT_UPLOAD_ISSUE",
  LOGIN_ACCESS_ISSUE = "LOGIN_ACCESS_ISSUE",
  PRODUCT_QUESTION = "PRODUCT_QUESTION",
  REGISTRATION_DATA_CHANGE = "REGISTRATION_DATA_CHANGE",
  OTHER = "OTHER",
  WHATSAPP_DIRECT = "WHATSAPP_DIRECT",
}

export const SUPPORT_REASON_LABEL: Record<SupportRequestReason, string> = {
  [SupportRequestReason.PROPOSAL_QUESTION]: "Dúvida sobre proposta",
  [SupportRequestReason.PROPOSAL_STUCK]: "Proposta travada",
  [SupportRequestReason.PLATFORM_BUG]: "Erro na plataforma",
  [SupportRequestReason.DOCUMENT_UPLOAD_ISSUE]:
    "Problema no envio de documentos",
  [SupportRequestReason.LOGIN_ACCESS_ISSUE]: "Problema de login/acesso",
  [SupportRequestReason.PRODUCT_QUESTION]: "Dúvida sobre produto",
  [SupportRequestReason.REGISTRATION_DATA_CHANGE]:
    "Alteração de dados cadastrais",
  [SupportRequestReason.OTHER]: "Outro",
  [SupportRequestReason.WHATSAPP_DIRECT]: "Direcionado ao WhatsApp",
};

export const optionsSupportRequestReasonSelect = Object.values(
  SupportRequestReason,
).map((reason) => ({
  value: reason,
  label: SUPPORT_REASON_LABEL[reason],
}));

export interface SupportRequestModalContext {
  reason?: SupportRequestReason;
  description?: string;
  product?: PartnerType;
  proposal?: string;
  transactionId?: string;
  metadata?: Record<string, unknown>;
}

export enum AttachmentType {
  IMAGE = "image",
  VIDEO = "video",
}

export interface SupportRequestAttachment {
  name: string;
  size: number;
  url: string;
  type: AttachmentType;
}

export interface SupportRequestActor {
  id?: string;
  name?: string;
}

export enum SupportRequestHistoryAction {
  UPDATE_STATUS = "UPDATE_STATUS",
  SELLER_REPLY = "SELLER_REPLY",
  CLAIM_TICKET = "CLAIM_TICKET",
  ASSIGN_TICKET = "ASSIGN_TICKET",
  ADD_COMMENT = "ADD_COMMENT",
}

export interface SupportRequestHistory {
  from?: SupportRequestStatusEnum;
  action: SupportRequestHistoryAction;
  to?: SupportRequestStatusEnum;
  actor?: SupportRequestActor;
  date: string;
  message?: string;
  attachments?: SupportRequestAttachment[];
}

export interface SupportRequest {
  _id: string;
  number?: string;
  startId?: string;
  status: SupportRequestStatusEnum;
  reason: SupportRequestReason;
  description?: string;
  transaction?: string;
  // vêm da transação vinculada no detalhe do chamado
  product?: PartnerType;
  proposal?: string;
  proposalStatus?: string;
  proposalValue?: number;
  proposalCreatedAt?: string;
  metadata?: Record<string, any>;
  seller?: {
    name?: string;
    email?: string;
    phone?: string;
    cpf?: string;
    id?: string;
  };
  history?: SupportRequestHistory[];
  attachments?: SupportRequestAttachment[];
  resolution?: string;
  resolvedAt?: Date;
  assignedTo?: {
    id: string;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface SupportRequestMessage {
  _id?: string;
  author?: string;
  message: string;
  createdAt: string;
}
